import type {
  InboxMessagesUpdatedSubscription,
  InboxMessagesUpdatedSubscriptionVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const INBOX_MESSAGES_UPDATED: TypedDocumentNode<
  InboxMessagesUpdatedSubscription,
  InboxMessagesUpdatedSubscriptionVariables
> = gql`
  subscription InboxMessagesUpdated {
    inboxMessagesUpdated {
      threadRootId
      participantUserIds
    }
  }
`;
